import { Input, type InputProps } from '@chakra-ui/react';
import { useMask } from '@react-input/mask';
import { forwardRef } from 'react';

const DateInput = forwardRef<HTMLInputElement, InputProps>(({ ...props }, ref) => {
  const inputRef = useMask({
    mask: '__/__/____',
    replacement: {
      _: /\d/,
    },
  });

  return <Input {...props} ref={inputRef} type="text" />;
});

export default DateInput;